import React from 'react';
import { Fade, Grow, Box } from '@mui/material';

export default function PageTransition({ children, timeout = 300 }) {
  return (
    <Fade in timeout={timeout}>
      <Grow in timeout={timeout + 100}>
        <Box>
          {children}
        </Box>
      </Grow>
    </Fade>
  );
}
